export const analytics = () => {
  const visitorAction = (props) => {
    const analyticsEnabled =
      process.env.NODE_ENV === 'development' ||
      window?._satellite?.tools?.['533b8d021c62394b378568aa4aa483a1']
        ?.initialized === true;
    try {
      if (analyticsEnabled) {
        sendAnalyticsData(props);
      }
    } catch (err) {
      console.error('Analytics error:' + err);
    }
  };

  const sendAnalyticsData = ({
    phase,
    error,
    language,
    pageName,
    phaseCategory,
    products,
  }) => {
    const language_name = { fi: 'fi_fi', sv: 'sv_se', en: 'en_us' }[language];
    const data = {
      channel: 'ha',
      group: 'contact',
      name: 'vv ha tarjouspyynto',
      businessGroup: 'insurance',
    };
    const { name, channel, group, businessGroup } = data;
    const phaseData = {
      name,
      group,
      channel,
      language: language_name,
      phase: phase,
      pageName: 'ha:ano:henkiloasiakkaat:vakuutukset:tarjouspyynto-' + pageName,
      phase_category: phaseCategory,
      business_group: businessGroup,
      products: products,
    };
    // Check: window._satellite = {track: (...args) => console.log("ARGS:",...args)};
    if (error === null) {
      window._satellite.track('application_phase', phaseData);
    } else if (error) {
      window._satellite.track('application_action', {
        action_name: 'no rights',
        action_group: 'error',
        name,
        group,
        business_group: businessGroup,
        channel,
        phase: phase,
        language: language_name,
        pageName:
          'ha:ano:henkiloasiakkaat:vakuutukset:tarjouspyynto-' + pageName,
        products: products,
      });
    }
  };
  return {
    visitorAction,
  };
};
